import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface RelatedArticlesProps {
  items: Article[];
}

export default function RelatedArticles({ items }: RelatedArticlesProps) {
  if (items.length === 0) return null;

  return (
    <section aria-labelledby="related-heading" className="border-t border-background-200 pt-10">
      <h2 id="related-heading" className="font-heading text-xl font-black text-foreground-950">
        相关解读
      </h2>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((article) => (
          <article key={article.id} className="group">
            <Link to={`/analysis/${article.slug}`} className="block cursor-pointer">
              <div className="h-36 w-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <img
                  src={article.cover}
                  alt={`${article.title} - ${article.category}相关解读配图`}
                  title={`${article.title} - 15黑料网事件分析`}
                  className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <p className="label-caps mt-4 text-[11px] text-primary-600">{article.category}</p>
              <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {article.title}
              </h3>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}